import { FiltersReq } from '@abstractTypes/filter'
import { ProductRequestConfigOverride } from './types'

const defaultExcludeFilters: FiltersReq = {}
const defaultConfigOverride: ProductRequestConfigOverride = {}

export { defaultExcludeFilters, defaultConfigOverride }
